export default __webpack_public_path__ + "static/media/Connectivity.a47df63f.svg";